import React, { useRef, useMemo } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import MermaidDiagram from './MermaidDiagram';

const MarkdownView = ({ content, disabled }) => {
    // Use a ref-based counter that resets on each render cycle to generate
    // stable, unique IDs per mermaid block without leaking across instances
    const counterRef = useRef(0);
    counterRef.current = 0;

    // Memoize components map so ReactMarkdown doesn't recreate it on every render
    const components = useMemo(() => ({
        code: ({ node, inline, className, children, ...props }) => {
            const language = /language-(\w+)/.exec(className || '')?.[1];
            const code = String(children).replace(/\n$/, '');
            if (!inline && language === 'mermaid') {
                counterRef.current += 1;
                return (
                    <MermaidDiagram
                        code={code}
                        id={`md-mermaid-${counterRef.current}`}
                        disabled={disabled}
                    />
                );
            }
            return (
                <code className={className} {...props}>
                    {children}
                </code>
            );
        },
    }), [disabled]);

    return (
        <div className={`markdown-render ${disabled ? 'markdown-disabled' : ''}`}>
            <ReactMarkdown
                remarkPlugins={[remarkGfm]}
                rehypePlugins={[rehypeRaw]}
                components={components}
            >
                {content || ''}
            </ReactMarkdown>
        </div>
    );
};

export default MarkdownView;
